import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

/** DEMO-ONLY: ERP option for click-to-fill on Request access. */
export type PresidioDemoErpRoute = 'admin' | 'csr' | 'not_found';

export interface PresidioDemoErpAccount {
  id: string;
  labelKey: string;
  outcomeKey: string;
  fillAriaKey: string;
  erpCustomerNo: string;
  companyName: string;
  route: PresidioDemoErpRoute;
}

/**
 * DEMO-ONLY: ERP numbers covering access-request routing (FR 1.2.1 / 1.2.7).
 * Must stay aligned with classifyPresidioAccessErp() in presidio-mock-discovery-handlers.
 * Known ERPs always have admin and/or CSR — contact-sales only for not found.
 */
export const PRESIDIO_DEMO_ERP_ACCOUNTS: readonly PresidioDemoErpAccount[] = [
  {
    id: 'admin',
    labelKey: 'account.request_access.demo.admin',
    outcomeKey: 'account.request_access.demo.admin.outcome',
    fillAriaKey: 'account.request_access.demo.admin.aria',
    erpCustomerNo: 'PCT-10042',
    companyName: 'Acme Corporation',
    route: 'admin',
  },
  {
    id: 'csr',
    labelKey: 'account.request_access.demo.csr',
    outcomeKey: 'account.request_access.demo.csr.outcome',
    fillAriaKey: 'account.request_access.demo.csr.aria',
    erpCustomerNo: 'ACME-NEW',
    companyName: 'Acme Industries',
    route: 'csr',
  },
  {
    id: 'not_found',
    labelKey: 'account.request_access.demo.not_found',
    outcomeKey: 'account.request_access.demo.not_found.outcome',
    fillAriaKey: 'account.request_access.demo.not_found.aria',
    erpCustomerNo: 'INVALID',
    companyName: '',
    route: 'not_found',
  },
];

/**
 * DEMO-ONLY — prototype picker for Request access ERP customer numbers.
 */
@Component({
  selector: 'ish-demo-erp-modal',
  templateUrl: './demo-erp-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DemoErpModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  readonly accounts = PRESIDIO_DEMO_ERP_ACCOUNTS;

  select(account: PresidioDemoErpAccount): void {
    this.activeModal.close(account);
  }

  hide(): void {
    this.activeModal.dismiss();
  }
}
